import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class TableProfileService extends CrudService {
  constructor() {
    super(API_RESOURCE.TABLE_PROFILE)
  }

  toggleActiveTableProfile = async (id) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/toggle-active`)
      return response.data
    } catch (error) {
      console.error(`Error toggle table profile status with id ${id}`, error)
      throw error
    }
  }

  addProfileToAllUsers = async (id) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/addToUsers`)
      return response.data
    } catch (error) {
      console.error(`Error Adding default profile to users with id ${id}`, error)
      throw error
    }
  }
}

export default TableProfileService
